import { getReqs, setupCreateUpdateClocks } from 'features/firebase-app'
import * as firestore from 'firebase/firestore'
// This import loads the firebase namespace along with all its type information.
import {
  addDoc,
  deleteDoc,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore'
import SocialMediaAccount from './social-media-account-model'
import {
  SocialMediaAccountMetaProperties,
  SocialMediaAccountProperties,
} from './socialMediaAccount-property-definitions'

export async function load_socialMediaAccounts($args: {
  uid: string
}): Promise<SocialMediaAccount[]> {
  let { db } = getReqs()
  let { uid } = $args
  let collection = firestore.collection(
    db,
    `socialMediaAccounts`,
    `${uid}`,
    'socialMediaAccount',
  )
  let result: SocialMediaAccount[] = []
  await firestore
    .getDocs(firestore.query(collection))
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        console.log(doc.id, ' => ', doc.data())
        result.push(convertTosocialMediaAccount(doc))
      })
    })
    .catch((error) => {
      console.log('Error getting documents: ', error)
    })
  return result.filter((x) => x)
}

function convertTosocialMediaAccount(doc: any) {
  let temp: any = {
    id: doc.id,
    ...doc.data(),
  }
  temp = {
    ...temp,
    fire_id: doc.id,
    id: doc.id,
  }
  setupCreateUpdateClocks(temp)

  return temp
}

export async function delete_socialMediaAccount(args: {
  uid: string
  id: string
}): Promise<boolean> {
  let { db } = getReqs()
  if (args.uid) {
    let obj = firestore.doc(
      db,
      `socialMediaAccounts`,
      `${args.uid}`,
      'socialMediaAccount',
      args.id,
    )
    await deleteDoc(obj)
    return true
  }
  return false
}

export async function store_socialMediaAccount(
  args: SocialMediaAccount,
): Promise<SocialMediaAccount> {
  let { db } = getReqs()
  let { owner, fire_id } = args
  if (fire_id) {
    // update
    let socialMediaAccount_collection = firestore.doc(
      db,
      `socialMediaAccounts`,
      `${owner}`,
      'socialMediaAccount',
      fire_id,
    )
    let temp: any = {
      version: (args.version || 0) + 1,
      owner,
    }
    ;[
      ...Object.values(SocialMediaAccountProperties),
      ...Object.values(SocialMediaAccountMetaProperties),
    ].forEach((prop) => {
      temp[prop] = (args as any)[prop]

      if (temp[prop] === undefined) {
        temp[prop] = null
      }
    })
    await updateDoc(socialMediaAccount_collection, {
      ...temp,
      updated: serverTimestamp(),
    })

    return temp
  } else {
    // add
    let collection = firestore.collection(
      db,
      `socialMediaAccounts`,
      `${owner}`,
      'socialMediaAccount',
    )
    let temp: any = {
      version: (args.version || 0) + 1,
      owner,
    }
    ;[
      ...Object.values(SocialMediaAccountProperties),
      ...Object.values(SocialMediaAccountMetaProperties),
    ].forEach((prop) => {
      temp[prop] = (args as any)[prop]

      if (temp[prop] === undefined) {
        temp[prop] = null
      }
    })
    const docRef = await addDoc(collection, {
      ...temp,
      created: serverTimestamp(),
    })

    console.log('Document written with ID: ', docRef.id)
    temp.id = docRef.id
    temp.fire_id = docRef.id
    return temp
  }
}
